import React from 'react';
import ReactDOM from 'react-dom';
import 'element-closest';

import { getDataConfig, formatFilters } from './utils/FilterConfigFormatter';
import TableFilters from './containers/TableFilters';

import './index.css';

const defualtNoResultsMessage = `No items match given criteria. You can either change the criteria or <button type="reset" form="filters" class="luna-button">Reset all</button> of them.`;
const createNoResultsTemplate = (message) => {
  const noResultsMessage = message || defualtNoResultsMessage;

  return `
    <tr class="no-results">
      <td>
        ${noResultsMessage}
      </td>
    </tr>
  `;
}

function initializeFilters(tableFiltersNode) {
  const wrapperNode = tableFiltersNode.closest('.js-comparison-calculator');
  const jsonData = getDataConfig(tableFiltersNode.innerText);
  const {
    filters,
    defaultTableFilter,
  } = formatFilters(jsonData.filters, jsonData.defaultTableFilter);
  const template = wrapperNode.getAttribute('data-template') || '';
  const site = wrapperNode.getAttribute('data-site') || '';
  const categoryId = wrapperNode.getAttribute('data-category') || '';
  const fieldset = wrapperNode.getAttribute('data-fieldset') || '';
  const origin = wrapperNode.getAttribute('data-origin') || '';
  const sort = wrapperNode.getAttribute('data-sort') || '';
  const throwOnEmptyFilters = false;
  const autoApply = true;
  const baseUrl = window.location.origin;
  const keepVisible = tableFiltersNode.getAttribute('data-keep-visible') === 'true';
  const leftSidePosition = tableFiltersNode.getAttribute('data-side-position') === 'true';
  const noResultsTemplate = createNoResultsTemplate(
    tableFiltersNode.getAttribute('data-no-results-message')
  );
  const table = wrapperNode.querySelector('.js-calculator-table');
  const pagination = table.getAttribute('data-pagination');

  const options = {
    template,
    site,
    categoryId,
    fieldset,
    origin,
    sort,
    throwOnEmptyFilters,
    baseUrl,
    noResultsTemplate,
    filters,
    defaultTableFilter,
    wrapperNode,
    tableFiltersNode,
    keepVisible,
    leftSidePosition,
    autoApply,
  };

  if (pagination) {
    options.pagination = pagination;
  }

  ReactDOM.render(<TableFilters {...options} />, tableFiltersNode);
}

document.addEventListener('DOMContentLoaded', () => {
  const tableFiltersNodes = [...document.querySelectorAll('.table-filters')];

  tableFiltersNodes.forEach(initializeFilters);
})



// WEBPACK FOOTER //
// ./src/index.js